'use strict';

window.cache = window.cache || {};

var genericHelper = {
    'generateCache': function (selectors, container) {
        var $cache = {};
        // eslint-disable-next-line
        for (var key in selectors) {
            if (!window.cache[key]) {
                window.cache[key] = container ? $(container).find(selectors[key]) : $(selectors[key]);
            }
            $cache[key] = window.cache[key];
        }

        return $cache;
    },
    'removeCacheData': function($cache, keys) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            window.cache[key] = null;
            $cache[key] = null;
        }

        return $cache;
    },
    'getCacheData': (keysArray) => {
        let cacheData = {};

        keysArray.forEach((key) => {
            try {
                let data = sessionStorage.getItem(key);
                if (data) {
                    cacheData[key] = data;
                } else {
                    cacheData[key] = null;
                }
            } catch (e) {
                cacheData[key] = null;
            }
        });

        return cacheData;
    },
    'setCacheData': (key, data) => {
        try {
            if (sessionStorage.getItem(key)) {
                return true;
            }
            sessionStorage.setItem(key, data);
        } catch (e) {
            return false;
        }

        return true;
    }
};

export default genericHelper;
